const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Generic API call function
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
    
    if (!response.ok) {
      throw new Error(`API call failed: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};

// Facility API functions
export const facilityApi = {
  // Get all facilities with optional filters
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return apiCall(`/api/facility/public/facilities${queryParams ? '?' + queryParams : ''}`);
  },

  // Get facility by ID
  getById: async (facilityId) => {
    return apiCall(`/api/facility/public/facilities/${facilityId}`);
  },

  // Get curated featured facilities
  getFeatured: async (limit = 6) => {
    return apiCall(`/api/facility/public/facilities/featured?limit=${limit}`);
  },

  // Get facilities by state
  getByState: async (stateCode, params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return apiCall(`/api/facility/public/states/${stateCode}/facilities${queryParams ? '?' + queryParams : ''}`);
  },

  // Search facilities
  search: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return apiCall(`/api/facility/public/search${queryParams ? '?' + queryParams : ''}`);
  },

  // Get statistics
  getStats: async () => {
    return apiCall('/api/facility/public/stats');
  }
};

// Helper function to handle API errors gracefully
export const handleApiError = (error, fallbackData = null) => {
  console.error('API Error:', error);
  
  // Return fallback data if available
  if (fallbackData) {
    return fallbackData;
  }
  
  // Return empty structure for common cases
  return {
    facilities: [],
    total: 0,
    page: 1,
    limit: 20
  };
};

// Helper function to convert URL query params to API parameters
export const parseSearchParams = (searchParams) => {
  const params = {};
  
  // Map common search params to API params
  if (searchParams.get('q')) params.q = searchParams.get('q');
  if (searchParams.get('state')) params.state = searchParams.get('state');
  if (searchParams.get('city')) params.city = searchParams.get('city');
  if (searchParams.get('treatment_types')) {
    params.treatment_types = searchParams.get('treatment_types').split(',');
  }
  if (searchParams.get('specializations')) {
    params.specializations = searchParams.get('specializations').split(',');
  }
  if (searchParams.get('page')) params.page = parseInt(searchParams.get('page'));
  if (searchParams.get('limit')) params.limit = parseInt(searchParams.get('limit'));
  
  return params;
};